import { site } from './site'

export type LegalSection = { heading: string; paragraphs: string[] }

export type LegalDoc = {
  title: string
  updated: string
  intro: string
  sections: LegalSection[]
}

/** What this site actually stores and loads. Keep in sync with src/lib/storage.ts and src/lib/analytics.ts. */
export const privacyPolicy: LegalDoc = {
  title: 'Privacy Policy',
  updated: 'November 2026',
  intro: `This policy covers ${site.url.replace('https://', '')}, the portfolio of ${site.name}. It is a plain-language summary, not legal advice.`,
  sections: [
    {
      heading: 'What this site collects',
      paragraphs: [
        'Nothing. The contact form opens your own email app with the message laid out — nothing is sent to or stored on this site.',
        'If you email me, your message and address stay in my inbox; I use them only to reply. Ask me any time to delete them.',
      ],
    },
    {
      heading: 'What your browser stores',
      paragraphs: [
        'Your theme choice (dark or light) and whether the sidebar is collapsed, in localStorage. Clearing your browser storage removes both.',
      ],
    },
    {
      heading: 'Analytics',
      paragraphs: ['No analytics runs on this site.'],
    },
    {
      heading: 'Hosting',
      paragraphs: [
        'The site is hosted by Lovable. Like any web host, it logs standard request data such as IP address, page requested and time.',
      ],
    },
    {
      heading: 'Your rights',
      paragraphs: [
        `Since nothing is collected on this site, there is nothing to request. For anything else, write to ${site.email}.`,
      ],
    },
    {
      heading: 'Changes',
      paragraphs: ['If this site ever starts collecting data, this policy is updated first, and the date above changes with it.'],
    },
  ],
}

export const termsOfService: LegalDoc = {
  title: 'Terms of Service',
  updated: 'November 2026',
  intro: 'These terms cover the use of this portfolio site.',
  sections: [
    {
      heading: 'The content',
      paragraphs: [
        'The projects described here are real builds. Details are shared at a level that respects client confidentiality.',
      ],
    },
    {
      heading: 'No warranty',
      paragraphs: ['The site is provided as is, with no warranty. Nothing on it is an offer or a binding quote.'],
    },
    {
      heading: 'Contact',
      paragraphs: [`Questions about these terms: ${site.email}.`],
    },
  ],
}
